// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3dgRv","inputWrap":"CustomTip_inputWrap__32hzo"};